import React from "react";

const Loading = ({ label }: { label: string }) => (
	<div className="addtocart-spinner" aria-live="assertive" role="alert">
		{label}
	</div>
);

export default Loading;
